import { useTranslations } from 'next-intl';
import { matchStyles } from '../match/match.style';
import { useAsianLines } from './contexts';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { PreferredMainBetType, PreferredSoccerMainBetType } from '@nf/types/account';
import { KafkaNote } from '@nf/utils-common/constants';
import { useAnalyseAttribute } from '@/features/next-analyse';

interface MoreLinesButtonProps {
	sport: number;
    betType: number;
	isMoreAsianLineFullWidth: boolean;
	preferredMainBetType: PreferredMainBetType;
}

export const MoreLinesButton = ({
	sport,
	betType,
	isMoreAsianLineFullWidth = false,
	preferredMainBetType
}: MoreLinesButtonProps) => {
	const { openMoreAsianLines } = useAsianLines();
	const t = useTranslations('General');
	const isFullTime = [1, 3].includes(betType);
	const label = isFullTime ? 'lbl_MarsMoreFTAsianLines' : 'lbl_MarsMore1HAsianLines';
	const view = useAppearanceStore(state => state.view);
	const analyseAttributeRef = useAnalyseAttribute('open-more-lines-button');
	const direction = preferredMainBetType[sport as keyof PreferredMainBetType] === PreferredSoccerMainBetType.OneXTwo 
		? 'start' 
		: 'end';

	return (
		<div 
			ref={analyseAttributeRef}
			className={matchStyles.asialine} 
			data-full-width={isMoreAsianLineFullWidth} 
			data-direction={direction}
			onClick={() => {
				openMoreAsianLines(isFullTime)
				if (view === ViewEnum.mars) {
					const kafkaData = {
						note: KafkaNote.MarsV1,
						type: 6,
						action: 8
					}
					setKafkaNormal(kafkaData);
				}
			}}
		>
			{t(label)}
		</div>
	)
}